module.exports = __webpack_public_path__ + "img/fun_swsb.ae035d3b.jpg";